import env from './env.mjs';

env(globalThis);
